export class JasperReportDetailsModel {
    ReportFile: string;
    ReportName: string;
    ReportPdfPath: string;
    ReportImagePath: string;
    ReportDicomPath: string;
    TotalPage: number;
  }
  